import moment from "moment";
import C from "Constants";
import { LocationIcon } from "config/Svgs";
import { FormatPreOrderingTime } from "utils/OrderUtils";
import { TranslationText } from "components/TextTranslationContainer";
import ConditionalRender from "components/ConditionalRenderer";

const SelectedLocation = ({
  storeName,
  orderTiming,
  title,
  onClick = () => {},
}) => {
  return (
    <div className="px-4 pt-4">
      <TranslationText className="text-16x font-semibold" text={title} />
      <div
        className="flex gap-1 items-center cursor-pointer mt-2"
        onClick={onClick}
      >
        <LocationIcon width={16} height={16} />
        <div className="text-shadow-forge-700 text-16x flex gap-1">
          <ConditionalRender
            condition={storeName}
            elseComponent={
              <TranslationText text="Select store" className="dummy-class" />
            }
          >
            <span>{storeName}</span>
            {orderTiming?.TimingType === C.ORDER_TIMING_TYPE.PREORDER &&
            orderTiming?.preOrderSlot?.day &&
            orderTiming?.preOrderSlot?.time ? (
              <span>
                {orderTiming?.preOrderSlot?.day === C.TODAY ? (
                  <TranslationText text={orderTiming?.preOrderSlot?.day} />
                ) : (
                  moment(orderTiming?.preOrderSlot?.day).format("dddd, DD MMM")
                )}
                {", "}
                {FormatPreOrderingTime(orderTiming?.preOrderSlot?.time)}
              </span>
            ) : (
              <TranslationText text="ASAP" className="text-brand-base-primary" />
            )}
          </ConditionalRender>
        </div>
      </div>
    </div>
  );
};

export default SelectedLocation;
